/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Indicator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Future from './Future/index'
import No from './No/index'
import Past from './Past/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Indicator({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Indicator"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventAppointmentBookingValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.booking',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventAppointmentBookingValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Past'}>
<Past
  viewPath={`${viewPath}/Past`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Future'}>
<Future
  viewPath={`${viewPath}/Future`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}